<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="editItem = {}"
    >
      Upload Client Document
    </v-btn>
    <client-documents-table-modal v-if="editItem && !editItemGroups" :edited-item="editItem" @close="editItem = null" @saved="editItem = null; $emit('update', $event)" />
    <client-document-groups-table v-if="editItemGroups" :edit-item-groups="editItemGroups" :edited-item="editItem" @close="editItemGroups = null; editItem = null" />
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      class="elevation-1"
      item-key="documentId"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <v-btn tooltip.hover title="Edit Client Document" icon class="mx-0" @click="editItem = cloneDeep(props.item)">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
            <v-btn tooltip.hover title="Delete Client Document" icon class="mx-0" @click="deleteThisClientDocument(props.item.documentId)">
              <v-icon color="primary">delete</v-icon>
            </v-btn>
            <v-btn tooltip.hover title="Manage Client Document Groups" icon class="mx-0" @click="getClientDocumentGroups(props.item.documentId).then(e => { editItemGroups = e.data; editItem = props.item }, () => {})">
              <v-icon color="primary">subdirectory_arrow_right</v-icon>
            </v-btn>
          </td>
          <td><A :href="clientUrls.changeClientDocument(props.item.documentId)" target="_blank">{{ props.item.description }}</A></td>
          <td>{{ props.item.documentType === 'C' ? 'Client' : props.item.documentType === 'M' ? 'Member' : props.item.documentType }}</td>
          <td>{{ props.item.lastModifiedAt | formatDate }}</td>
          <td>{{ props.item.lastModifiedBy }}</td>
          <td>{{ props.item.documentLength | formatBytes }}</td>
          <td>{{ props.item.mimeType }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import ClientDocumentsTableModal from './ClientDocumentsTableModal'
import ClientDocumentGroupsTable from './ClientDocumentGroupsTable'
import cloneDeep from 'lodash/cloneDeep'
import { mapActions } from 'vuex'
import clientUrls from '../../store/modules/manageClientDocument.urls'

export default {
  name: 'client-documents-table',
  components: {
    ClientDocumentsTableModal,
    ClientDocumentGroupsTable
  },
  props: {
    tableItems: Array
  },
  data() {
    return {
      clientUrls: clientUrls,
      editItem: null,
      editItemGroups: null,
      tableHeaders: [
        {
          text: 'Actions',
          value: false,
          sortable: false
        }, {
          text: 'Display Name',
          value: 'description'
        },
        {
          text: 'Type',
          value: 'documentType'
        },
        {
          text: 'Updated Date',
          value: 'lastModifiedAt'
        },
        {
          text: 'Updated By',
          value: 'lastModifiedBy'
        },
        {
          text: 'File Size',
          value: 'documentLength'
        },
        {
          text: 'File Type',
          value: 'mimeType'
        }
      ]
    }
  },
  created() {
    this.getUserGroups()
  },
  methods: {
    cloneDeep: cloneDeep,
    ...mapActions('manageClientDocuments', ['deleteClientDocument', 'getClientDocumentGroups']),
    ...mapActions('manageUsers', ['getUserGroups']),
    deleteThisClientDocument: function(documentId) {
      confirm('Are you sure?') &&
      this.deleteClientDocument(documentId).then(e => this.$emit('update', e.data), () => {})
    }
  }
}
</script>
